import type { GzStatus } from '../../api/securiteeGravityZone'
import { GZ_LABEL_CLASS } from './gzColumn'
import './gravityzone.css'

/** Eticheta GravityZone a unui aparat, cu motivele dedesubt (`withReasons`). */
export function GzStatusLabel({ status, withReasons = false }: { status: GzStatus; withReasons?: boolean }) {
  return (
    <span className={'gz-status gz-status-' + status.status}>
      <span className={'label ' + GZ_LABEL_CLASS[status.status]}>{status.label}</span>
      {withReasons && status.reasons.length > 0 && <span className="gz-status-reasons">{status.reasons.join(' · ')}</span>}
    </span>
  )
}
